import script from "./WarningCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningCard.vue?vue&type=script&setup=true&lang=ts"

import "./WarningCard.vue?vue&type=style&index=0&id=651c0f3c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651c0f3c"]])

export default __exports__